// Main offline module entry point.
// Exports the public API for the offline system.

import DB from './db'
import Router from './router'
import Sync from './sync'
import Util from './util'
import FilterWarm from './filter/warm'
import AccountsExistsAPI from './api/accounts/exists'
import AccountsForgotAPI from './api/accounts/forgot'
import AccountsRegisterAPI from './api/accounts/register'
import AccountsResetAPI from './api/accounts/reset'
import AccountsSettingsAPI from './api/accounts/settings'
import AccountsUpgradeAPI from './api/accounts/upgrade'
import AccountsVerifyAPI from './api/accounts/verify'
import ActionsRunAPI from './api/actions/run'
import ActivityDeleteAPI from './api/activity/delete'
import UsersCollectionAPI from './api/users/collection'
import UsersFiltersAPI from './api/users/filters'
import UsersActivityAPI from './api/users/activity'
import UsersIndexAPI from './api/users/index'
import UsersInsightsAPI from './api/users/insights'
import UsersListingAPI from './api/users/listing'
import UsersListsAPI from './api/users/lists'
import UsersPlaysAPI from './api/users/plays'
import UsersRatingsAPI from './api/users/ratings'
import UsersSyncAPI from './api/users/sync'
import UsersToolsAPI from './api/users/tools'
import UsersVerifyAPI from './api/users/verify'
import GroupsCollectionAPI from './api/groups/collection'
import GroupsActivityAPI from './api/groups/activity'
import GroupsIndexAPI from './api/groups/index'
import GroupsInsightsAPI from './api/groups/insights'
import GroupsListingAPI from './api/groups/listing'
import GroupsListsAPI from './api/groups/lists'
import GroupsPlaysAPI from './api/groups/plays'
import GroupsRatingsAPI from './api/groups/ratings'
import GroupsUsersAPI from './api/groups/users'
import GroupsVerifyAPI from './api/groups/verify'
import BuddiesCollectionAPI from './api/buddies/collection'
import BuddiesActivityAPI from './api/buddies/activity'
import BuddiesIndexAPI from './api/buddies/index'
import BuddiesInsightsAPI from './api/buddies/insights'
import BuddiesListingAPI from './api/buddies/listing'
import BuddiesListsAPI from './api/buddies/lists'
import BuddiesPlaysAPI from './api/buddies/plays'
import BuddiesRatingsAPI from './api/buddies/ratings'
import BuddiesSyncAPI from './api/buddies/sync'
import BuddiesUsersAPI from './api/buddies/users'
import BuddiesVerifyAPI from './api/buddies/verify'
import GamesAboutAPI from './api/games/about'
import GamesCommentsAPI from './api/games/comments'
import GamesExpansionsAPI from './api/games/expansions'
import GamesSearchAPI from './api/games/search'
import GamesSuggestAPI from './api/games/suggest'
import AppAboutAPI from './api/app/about'
import AppDevlogAPI from './api/app/devlog'
import AppHelpAPI from './api/app/help'
import AppNotificationsAPI from './api/app/notifications'
import AppPrivacyAPI from './api/app/privacy'
import AppSyncsAPI from './api/app/syncs'
import AppTermsAPI from './api/app/terms'
import ArtistsSuggestAPI from './api/artists/suggest'
import CategoriesSuggestAPI from './api/categories/suggest'
import CommunityAccessAPI from './api/community/access'
import CommunityPatreonAPI from './api/community/patreon'
import CommunityVotingAPI from './api/community/voting'
import ConfigAPI from './api/config/index'
import ConfigSaveAPI from './api/config/save'
import CustomNestingAddAPI from './api/custom/nesting/add'
import CustomNestingClearAPI from './api/custom/nesting/clear'
import CustomNestingRemoveAPI from './api/custom/nesting/remove'
import CustomNestingRestoreAPI from './api/custom/nesting/restore'
import CustomRenameCreateAPI from './api/custom/rename/create'
import CustomRenameDeleteAPI from './api/custom/rename/delete'
import DesignersSuggestAPI from './api/designers/suggest'
import ExportClipboardAPI from './api/export/clipboard'
import ExportCSVAPI from './api/export/csv'
import FamiliesSuggestAPI from './api/families/suggest'
import GamesAPI from './api/games/index'
import GamesAvatarAPI from './api/games/avatar'
import GroupsAddAPI from './api/groups/add'
import GroupsCreateAPI from './api/groups/create'
import GroupsDeleteAPI from './api/groups/delete'
import GroupsEditAPI from './api/groups/edit'
import GroupsJoinAPI from './api/groups/join'
import GroupsLeaveAPI from './api/groups/leave'
import GroupsRemoveAPI from './api/groups/remove'
import HindexCreateAPI from './api/hindex/create'
import HindexTrackAPI from './api/hindex/track'
import HindexUntrackAPI from './api/hindex/untrack'
import HindexUpdateAPI from './api/hindex/update'
import LanguagesSuggestAPI from './api/languages/suggest'
import ListingSharedAPI from './api/listing'
import ListingAddAPI from './api/listing/add'
import ListingColumnsAPI from './api/listing/columns'
import ListingCreateAPI from './api/listing/create'
import ListingDeleteAPI from './api/listing/delete'
import ListingEditAPI from './api/listing/edit'
import ListingEditionCreateAPI from './api/listing/edition/create'
import ListingEditionDeleteAPI from './api/listing/edition/delete'
import ListingFilterAPI from './api/listing/filter'
import ListingItemCommentAPI from './api/listing/item/comment'
import ListingOrderAPI from './api/listing/order'
import ListingRemoveAPI from './api/listing/remove'
import ListingSuggestAPI from './api/listing/suggest'
import LocationsSuggestAPI from './api/locations/suggest'
import MechanicsSuggestAPI from './api/mechanics/suggest'
import MiscSuggestPlayUsernamesAPI from './api/misc/suggest/play/usernames'
import PlayersSuggestAPI from './api/players/suggest'
import PresetsAPI from './api/presets/index'
import PresetsCreateAPI from './api/presets/create'
import PresetsDefaultedAPI from './api/presets/defaulted'
import PresetsDeleteAPI from './api/presets/delete'
import PresetsEditAPI from './api/presets/edit'
import PresetsSaveAPI from './api/presets/save'
import PatreonChangeAPI from './api/patreon/change'
import PublishersSuggestAPI from './api/publishers/suggest'
import SelectAPI from './api/select/index'
import SessionIndexAPI from './api/session/index'
import SessionCheckAPI from './api/session/check'
import SessionBoostsAPI from './api/session/boosts'
import SessionEarlyAPI from './api/session/early'
import SessionExternaldomainsAPI from './api/session/externaldomains'
import SessionGroupSyncsAPI from './api/session/groupsyncs'
import SessionLoginAPI from './api/session/login'
import SessionLogoutAPI from './api/session/logout'
import SessionPatreonAPI from './api/session/patreon'
import SessionPatreonConnectAPI from './api/session/patreon/connect'
import SessionSubdomainsAPI from './api/session/subdomains'
import SessionSyncAPI from './api/session/sync'
import SessionSyncTypeAPI from './api/session/synctype'
import SessionSyncsAPI from './api/session/syncs'
import SubdomainsSuggestAPI from './api/subdomains/suggest'
import TagsAddAPI from './api/tags/add'
import TagsClearAPI from './api/tags/clear'
import TagsCreateAPI from './api/tags/create'
import TagsDeleteAPI from './api/tags/delete'
import TagsMoveAPI from './api/tags/move'
import TagsRemoveAPI from './api/tags/remove'
import TagsToggleAPI from './api/tags/toggle'
import TagsUpdateAPI from './api/tags/update'
import TagsFamilyCreateAPI from './api/tags/family/create'
import TagsFamilyDeleteAPI from './api/tags/family/delete'
import TagsFamilyUpdateAPI from './api/tags/family/update'
import ViewsCreateAPI from './api/views/create'
import ViewsDefaultAPI from './api/views/defallt'
import ViewsManageAPI from './api/views/manage'
import ViewsFieldRemoveAPI from './api/views/field/remove'
import ViewsFieldSaveAPI from './api/views/field/save'
import ViewsViewRemoveAPI from './api/views/view/remove'
import ViewsViewSaveAPI from './api/views/view/save'
import UsersAvatarAPI from './api/users/avatar'
import UsersSuggestAPI from './api/users/suggest'

var Offline = {

	DB: DB,
	Router: Router,
	Sync: Sync,
	Util: Util,

	// Initialize the offline system.
	// Call this early in app bootstrap (before any API calls).
	init: function() {
		Router.init()

		// Register offline endpoint handlers
		Router.register('accounts/exists', AccountsExistsAPI)
		Router.register('accounts/forgot', AccountsForgotAPI)
		Router.register('accounts/register', AccountsRegisterAPI)
		Router.register('accounts/reset', AccountsResetAPI)
		Router.register('accounts/settings', AccountsSettingsAPI)
		Router.register('accounts/upgrade', AccountsUpgradeAPI)
		Router.register('accounts/verify', AccountsVerifyAPI)
		Router.register('actions/run', ActionsRunAPI)
		Router.register('activity/delete', ActivityDeleteAPI)
		Router.register('artists/suggest', ArtistsSuggestAPI)
		Router.register('users', UsersIndexAPI)
		Router.register('users/activity', UsersActivityAPI)
		Router.register('users/avatar', UsersAvatarAPI)
		Router.register('users/collection', UsersCollectionAPI)
		Router.register('users/filters', UsersFiltersAPI)
		Router.register('users/insights', UsersInsightsAPI)
		Router.register('users/list', UsersListingAPI)
		Router.register('users/listing', UsersListingAPI)
		Router.register('users/lists', UsersListsAPI)
		Router.register('users/suggest', UsersSuggestAPI)
		Router.register('groups/activity', GroupsActivityAPI)
		Router.register('groups/add', GroupsAddAPI)
		Router.register('groups/collection', GroupsCollectionAPI)
		Router.register('groups/create', GroupsCreateAPI)
		Router.register('groups/delete', GroupsDeleteAPI)
		Router.register('groups/edit', GroupsEditAPI)
		Router.register('groups/insights', GroupsInsightsAPI)
		Router.register('groups/join', GroupsJoinAPI)
		Router.register('groups/leave', GroupsLeaveAPI)
		Router.register('groups/list', GroupsListingAPI)
		Router.register('groups/listing', GroupsListingAPI)
		Router.register('groups/lists', GroupsListsAPI)
		Router.register('buddies/activity', BuddiesActivityAPI)
		Router.register('buddies/collection', BuddiesCollectionAPI)
		Router.register('buddies/insights', BuddiesInsightsAPI)
		Router.register('buddies/list', BuddiesListingAPI)
		Router.register('buddies/listing', BuddiesListingAPI)
		Router.register('buddies/lists', BuddiesListsAPI)
		Router.register('buddies/sync', BuddiesSyncAPI)
		Router.register('users/plays', UsersPlaysAPI)
		Router.register('users/ratings', UsersRatingsAPI)
		Router.register('users/sync', UsersSyncAPI)
		Router.register('users/tools', UsersToolsAPI)
		Router.register('users/verify', UsersVerifyAPI)
		Router.register('groups', GroupsIndexAPI)
		Router.register('groups/plays', GroupsPlaysAPI)
		Router.register('groups/ratings', GroupsRatingsAPI)
		Router.register('groups/remove', GroupsRemoveAPI)
		Router.register('groups/users', GroupsUsersAPI)
		Router.register('groups/verify', GroupsVerifyAPI)
		Router.register('buddies', BuddiesIndexAPI)
		Router.register('buddies/plays', BuddiesPlaysAPI)
		Router.register('buddies/ratings', BuddiesRatingsAPI)
		Router.register('buddies/users', BuddiesUsersAPI)
		Router.register('buddies/verify', BuddiesVerifyAPI)
		Router.register('games/about', GamesAboutAPI)
		Router.register('games/avatar', GamesAvatarAPI)
		Router.register('games/comments', GamesCommentsAPI)
		Router.register('games/expansions', GamesExpansionsAPI)
		Router.register('games/search', GamesSearchAPI)
		Router.register('games/suggest', GamesSuggestAPI)
		Router.register('games', GamesAPI)
		Router.register('app/about', AppAboutAPI)
		Router.register('app/devlog', AppDevlogAPI)
		Router.register('app/help', AppHelpAPI)
		Router.register('app/notifications', AppNotificationsAPI)
		Router.register('app/privacy', AppPrivacyAPI)
		Router.register('app/syncs', AppSyncsAPI)
		Router.register('app/terms', AppTermsAPI)
		Router.register('categories/suggest', CategoriesSuggestAPI)
		Router.register('community/access', CommunityAccessAPI)
		Router.register('community/patreon', CommunityPatreonAPI)
		Router.register('community/voting', CommunityVotingAPI)
		Router.register('config', ConfigAPI)
		Router.register('config/save', ConfigSaveAPI)
		Router.register('custom/nesting/add', CustomNestingAddAPI)
		Router.register('custom/nesting/clear', CustomNestingClearAPI)
		Router.register('custom/nesting/remove', CustomNestingRemoveAPI)
		Router.register('custom/nesting/restore', CustomNestingRestoreAPI)
		Router.register('custom/rename/create', CustomRenameCreateAPI)
		Router.register('custom/rename/delete', CustomRenameDeleteAPI)
		Router.register('designers/suggest', DesignersSuggestAPI)
		Router.register('export/clipboard', ExportClipboardAPI)
		Router.register('export/csv', ExportCSVAPI)
		Router.register('families/suggest', FamiliesSuggestAPI)
		Router.register('hindex/create', HindexCreateAPI)
		Router.register('hindex/track', HindexTrackAPI)
		Router.register('hindex/untrack', HindexUntrackAPI)
		Router.register('hindex/:id', HindexUpdateAPI)
		Router.register('languages/suggest', LanguagesSuggestAPI)
		Router.register('list', ListingSharedAPI)
		Router.register('list/add', ListingAddAPI)
		Router.register('list/columns', ListingColumnsAPI)
		Router.register('list/create', ListingCreateAPI)
		Router.register('list/delete', ListingDeleteAPI)
		Router.register('list/edit', ListingEditAPI)
		Router.register('list/edition/create', ListingEditionCreateAPI)
		Router.register('list/edition/delete', ListingEditionDeleteAPI)
		Router.register('list/filter', ListingFilterAPI)
		Router.register('list/item/comment', ListingItemCommentAPI)
		Router.register('list/order', ListingOrderAPI)
		Router.register('list/remove', ListingRemoveAPI)
		Router.register('list/suggest', ListingSuggestAPI)
		Router.register('listing/add', ListingAddAPI)
		Router.register('listing/columns', ListingColumnsAPI)
		Router.register('listing/create', ListingCreateAPI)
		Router.register('listing/delete', ListingDeleteAPI)
		Router.register('listing/edit', ListingEditAPI)
		Router.register('listing/edition/create', ListingEditionCreateAPI)
		Router.register('listing/edition/delete', ListingEditionDeleteAPI)
		Router.register('listing/filter', ListingFilterAPI)
		Router.register('listing/item/comment', ListingItemCommentAPI)
		Router.register('listing/order', ListingOrderAPI)
		Router.register('listing/remove', ListingRemoveAPI)
		Router.register('listing/suggest', ListingSuggestAPI)
		Router.register('locations/suggest', LocationsSuggestAPI)
		Router.register('mechanics/suggest', MechanicsSuggestAPI)
		Router.register('misc/suggest/play/usernames', MiscSuggestPlayUsernamesAPI)
		Router.register('players/suggest', PlayersSuggestAPI)
		Router.register('presets', PresetsAPI)
		Router.register('presets/create', PresetsCreateAPI)
		Router.register('presets/defaulted', PresetsDefaultedAPI)
		Router.register('presets/delete', PresetsDeleteAPI)
		Router.register('presets/edit', PresetsEditAPI)
		Router.register('presets/save', PresetsSaveAPI)
		Router.register('patreon/change', PatreonChangeAPI)
		Router.register('publishers/suggest', PublishersSuggestAPI)
		Router.register('select', SelectAPI)
		Router.register('session', SessionIndexAPI)
		Router.register('session/check', SessionCheckAPI)
		Router.register('session/boosts', SessionBoostsAPI)
		Router.register('session/early', SessionEarlyAPI)
		Router.register('session/externaldomains', SessionExternaldomainsAPI)
		Router.register('session/groupsyncs', SessionGroupSyncsAPI)
		Router.register('session/login', SessionLoginAPI)
		Router.register('session/logout', SessionLogoutAPI)
		Router.register('session/patreon', SessionPatreonAPI)
		Router.register('session/patreon/connect', SessionPatreonConnectAPI)
		Router.register('session/subdomains', SessionSubdomainsAPI)
		Router.register('session/sync', SessionSyncAPI)
		Router.register('session/synctype', SessionSyncTypeAPI)
		Router.register('session/syncs', SessionSyncsAPI)
		Router.register('subdomains/suggest', SubdomainsSuggestAPI)
		Router.register('tags/add', TagsAddAPI)
		Router.register('tags/clear', TagsClearAPI)
		Router.register('tags/create', TagsCreateAPI)
		Router.register('tags/delete', TagsDeleteAPI)
		Router.register('tags/move', TagsMoveAPI)
		Router.register('tags/remove', TagsRemoveAPI)
		Router.register('tags/toggle', TagsToggleAPI)
		Router.register('tags/update', TagsUpdateAPI)
		Router.register('tags/family/create', TagsFamilyCreateAPI)
		Router.register('tags/family/delete', TagsFamilyDeleteAPI)
		Router.register('tags/family/update', TagsFamilyUpdateAPI)
		Router.register('views/create', ViewsCreateAPI)
		Router.register('views/default', ViewsDefaultAPI)
		Router.register('views/defallt', ViewsDefaultAPI)
		Router.register('views/manage', ViewsManageAPI)
		Router.register('views/field/remove', ViewsFieldRemoveAPI)
		Router.register('views/field/save', ViewsFieldSaveAPI)
		Router.register('views/view/remove', ViewsViewRemoveAPI)
		Router.register('views/view/save', ViewsViewSaveAPI)

		// Pre-initialize the database in the background if we have existing data
		DB.init().catch(function() {
			// Silently fail - database will be created on first sync
		})

		// Eager-load filter pipeline indexes so the cost of `require.context`
		// walking 100+ filter/sort/package modules lands at app init rather
		// than on the first filter call (most visibly: `insights/ratings/disparities`).
		FilterWarm.run()

		return Offline
	},

	// Convenience: set the routing mode.
	setMode: function(mode) {
		Router.setMode(mode)
	},

	// Convenience: register a local endpoint handler.
	register: function(endpoint, handler) {
		Router.register(endpoint, handler)
	},

	// Convenience: get status.
	status: function() {
		return Router.status()
	}

}

export default Offline
